export default class CollisionMark {
  constructor(x, y, antId, edge, timestamp = Date.now()) {
    this.x = x;
    this.y = y;
    this.antId = antId;
    this.edge = edge;
    this.timestamp = timestamp;
  }
}
